import React, { useState } from 'react';
import { PILOT_STATUS } from '../../../../constants/pilotStatus';
import { GraphSettingsPopup } from '../GraphSettingsPopup.component';
import { fput } from '../../../../lib/fetch';

const deviceOrder = [
  "DEVICE_1718433046201",
  "DEVICE_1717950746514",
  "DEVICE_1751587938731",
  "DEVICE_1746355078543",
  "DEVICE_1746355283533"
];

interface DeviceMarkerPopupProps {
  data: {
    DEVICE_ID: { S: string };
    DEVICE_NAME: { S: string };
    WATER_LEVEL: { S: string };
    FLOW_RATE?: { S: string };
    VELOCITY?: { S: string };
    AREA_NAME?: { S: string };
    pilot_status?: string;
    predicted_time?: string;
    predicted_ranges?: number;
    passedTime?: string;
    passTimestamp?: string;
    isPilotCheck?: boolean;
  };
  onDataUpdate?: () => void;
}

export const DeviceMarkerPopup: React.FC<DeviceMarkerPopupProps> = ({ data, onDataUpdate }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isLoadingPilotCheck, setIsLoadingPilotCheck] = useState(false);

  const waterLevel = data.WATER_LEVEL?.S && !isNaN(parseFloat(data.WATER_LEVEL.S))
    ? parseFloat(data.WATER_LEVEL.S).toFixed(3)
    : '-';

  const predictedTimeConvert = data.predicted_time
    ? (() => {
      const start = new Date(data.predicted_time);
      const end = new Date(start.getTime() + ((data.predicted_ranges || 0) * 60000));
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(start.getHours())}:${pad(start.getMinutes())}~${pad(end.getHours())}:${pad(end.getMinutes())}`;
    })()
    : 'Unavailable';

  const passedTimeConvert = data.passedTime
    ? `${String(new Date(data.passedTime).getHours()).padStart(2, '0')}:${String(new Date(data.passedTime).getMinutes()).padStart(2, '0')}`
    : 'Unknown';

  const togglePilotCheck = async () => {
    const deviceData = { ...data };
    deviceData.isPilotCheck = !deviceData.isPilotCheck;

    setIsLoadingPilotCheck(true);
    try {
      await fput<any, any>(`/api/areas/nodes/${deviceData.AREA_NAME?.S}/${deviceData.DEVICE_ID.S}/data`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          data: deviceData
        },
      });
      console.log('Toggle pilot check success');
      if (onDataUpdate) {
        onDataUpdate();
      }
    } catch (err) {
      console.error('Toggle pilot check failed:', err);
    } finally {
      setIsLoadingPilotCheck(false);
    }
  };

  const renderPassedStatus = () => (
    <>
      <span className="whitespace-nowrap text-center text-black text-sm">
        豌ｴ蜈亥芦驕・ {passedTimeConvert}
      </span>
      <p className="text-xs mt-1">豌ｴ蜈亥芦驕疲凾髢薙ｒ遒ｺ螳壹＠縺ｾ縺励◆縲・</p>
      <div className="flex flex-col gap-2 px-2 py-2 w-full">
        <button
          className="rounded bg-amber-400 px-2 py-1 text-xs text-white hover:bg-amber-500 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={(e) => {
            e.stopPropagation();
            setShowPopup(true);
          }}
          type="button"
          disabled={isLoadingPilotCheck}
        >
          繝ｪ繧ｻ繝・ヨ
        </button>
      </div>
    </>
  );

  const renderConfirmingStatus = () => (
    <>
      <span className="whitespace-nowrap text-center text-red-600 text-sm">
        豌ｴ蜈亥芦驕・ {passedTimeConvert}
      </span>
      <span className="whitespace-nowrap text-center text-red-600 text-xs mt-1">
        豌ｴ蜈亥芦驕斐ｒ蛻､譁ｭ縺励※縺上□縺輔＞縲・
      </span>
      <div className="flex flex-col gap-2 px-2 py-2 w-full">
        <button
          className="rounded bg-red-600 px-3 py-1 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={(e) => {
            e.stopPropagation();
            setShowPopup(true);
          }}
          type="button"
          disabled={isLoadingPilotCheck}
        >
          豌ｴ蜈亥愛螳・
        </button>
        <button
          className="rounded bg-gray-200 px-2 py-1 text-xs text-gray-600 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          onClick={(e) => {
            e.stopPropagation();
            togglePilotCheck();
          }}
          type="button"
          disabled={isLoadingPilotCheck}
        >
          {isLoadingPilotCheck && (
            <svg className="animate-spin h-3 w-3 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          )}
          {isLoadingPilotCheck ? '蜃ｦ逅・ｸｭ...' : '豌ｴ蜈域､懷・蜀埼幕'}
        </button>
      </div>
    </>
  );

  const renderNotPassStatus = () => (
    <>
      <span
        className="whitespace-nowrap text-center text-sm"
        style={{ color: "rgb(3 105 161)" }}
      >
        豌ｴ蜈亥芦驕比ｺ域ｸｬ: {predictedTimeConvert}
      </span>
      <div className="flex flex-col gap-2 px-2 py-2 w-full">
        <button
          className="rounded bg-emerald-600 px-2 py-1 text-xs text-white hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={(e) => {
            e.stopPropagation();
            setShowPopup(true);
          }}
          type="button"
          disabled={isLoadingPilotCheck}
        >
          豌ｴ蜈亥愛螳・
        </button>
        <button
          className="rounded bg-gray-200 px-2 py-1 text-xs text-gray-600 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          onClick={(e) => {
            e.stopPropagation();
            togglePilotCheck();
          }}
          type="button"
          disabled={isLoadingPilotCheck}
        >
          {isLoadingPilotCheck && (
            <svg className="animate-spin h-3 w-3 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          )}
          {isLoadingPilotCheck ? '蜃ｦ逅・ｸｭ...' : '豌ｴ蜈域､懷・蜀埼幕'}
        </button>
      </div>
    </>
  );

  const renderPilotStatusContent = () => {
    if (data.pilot_status === PILOT_STATUS.PASSED) {
      return renderPassedStatus();
    } else if (data.pilot_status === PILOT_STATUS.CONFIRMING) {
      return renderConfirmingStatus();
    } else if (data.pilot_status === PILOT_STATUS.NOT_PASS) {
      return renderNotPassStatus();
    }
    return null;
  };

  return (
    <div className="flex flex-col border border-sky-400 bg-white min-w-[180px]">
      <div className="bg-sky-700 p-1.5 text-white text-center">
        <span className="text-sm font-semibold">{data.DEVICE_NAME.S}</span>
      </div>

      <div className="bg-slate-100 px-2 py-1 text-center">
        <span className="text-xs whitespace-nowrap">
          {waterLevel} m
        </span>
      </div>

      {/*
      <div className="bg-white px-2 py-2 text-center border-t border-sky-400">
        <div className="flex flex-col items-center text-xs">
          {renderPilotStatusContent()}
          {data.isPilotCheck && (
            <span className="text-xs mt-2 text-gray-600">豌ｴ蜈亥芦驕斐ｒ遒ｺ隱堺ｸｭ...</span>
          )}
        </div>
      </div>

      <GraphSettingsPopup
        isOpen={showPopup}
        onClose={(shouldRefresh) => {
          setShowPopup(false);
          if (shouldRefresh && onDataUpdate) {
            onDataUpdate();
          }
        }}
        deviceData={data as any}
        predictedTimeConvert={predictedTimeConvert}
        passedTimeConvert={passedTimeConvert}
        deviceOrder={deviceOrder}
      />
      */}
    </div>
  );
};
